<script setup>
import {ref} from 'vue';

// Components
import Icon from '@/Components/Images/Icon.vue';
import NavigationDropdownMenu from '@/Components/Navigation/NavigationDropdownMenu.vue';

// Icons
import arrow from '@i/arrow-down.svg';

const dropdownOpen = ref(false);

const props = defineProps({
    title: String,
    href: String,
    childItems: Object,
});
</script>

<template>
    <div
        v-if="title"
        class="w-full"
        @click="dropdownOpen = !dropdownOpen"
    >
        <div
            class="relative"
            x-data="{ open: false }"
            @click.away="open = false"
        >
            <button
                v-if="!href"
                class="group relative flex w-full flex-col items-center justify-center"
            >
                <div class="flex size-full items-center justify-between gap-2 font-bold">
                    <span> {{ title }}</span>
                    <Icon
                        class="flex items-center justify-between transition-all xl:hidden"
                        :class="{ '-rotate-180': dropdownOpen }"
                        :icon="arrow"
                        alt="icon"
                    />
                    <Icon
                        class="hidden size-4 items-center transition-all xl:flex"
                        :class="{ '-rotate-180': dropdownOpen }"
                        :icon="arrow"
                        alt="icon"
                    />
                </div>
            </button>
            <NavigationDropdownMenu
                v-if="dropdownOpen && childItems.length"
                :dropdown-open="dropdownOpen"
            >
                <div class="relative lg:min-w-[230px] xl:-mt-2 xl:bg-grey">
                    <ul>
                        <li
                            v-for="(item, i) in childItems"
                            :key="i"
                        >
                            <a
                                v-if="item.data.title"
                                :key="i"
                                class="lg:hover:text-primary-text top-10 block w-full bg-transparent px-6 py-3 lg:mt-2 lg:hover:bg-primary"
                                :href="item.data.url"
                            >
                                <span class="flex items-center gap-2">
                                    {{ item.data.title }}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </NavigationDropdownMenu>
        </div>
    </div>
</template>
